import {
  SET_ANNOTATIONS_COMMENTS_LOADED,
  SET_ANNOTATIONS_IS_COMMENTS_FILTERED
} from './types'

export const setAnnotationsCommentsLoaded = (isLoaded: boolean): {type: string; isLoaded: boolean} => ({
  type: SET_ANNOTATIONS_COMMENTS_LOADED,
  isLoaded
})

export const setAnnotationsCommentsIsFiltered = (isFiltered: boolean): {type: string; isFiltered: boolean} => ({
  type: SET_ANNOTATIONS_IS_COMMENTS_FILTERED,
  isFiltered
})
